import { z } from 'zod';

// Zod schema for tracking data
export const trackingSchema = z.object({
  isRead: z.boolean(),
  isStarred: z.boolean(),
  isFollowing: z.boolean(),
  lastReadAt: z.string().optional()
});

export const trackingUpdateSchema = trackingSchema.partial();

// TypeScript type inferred from Zod schema
export type Tracking = z.infer<typeof trackingSchema>;
export type TrackingUpdate = Partial<Tracking>;
